import { z } from 'zod'
import { isValidDateString } from '@/common/utils/dateValidator'
import { optionSchema } from '@/common/schemas/option.schema'

export const createSchema = z.object({
  display_name: z
    .string()
    .min(3, { message: 'Tamanho mínimo: 3 caracteres' })
    .max(64, { message: 'Tamanho máximo: 64 caracteres' }),
  observations: z.string().min(8, { message: 'Tamanho mínimo: 8 caracteres' }),
  general_information: z.object({
    cnpj: z.string().refine((value) => value.length === 14 || value.length === 18, {message: 'Insira um CNPJ/CPF válido'}),
  }),
  bidding_information: z.object({
    notice_number: z.string().min(1, 'Campo obrigatório').max(64, 'Tamanho máximo: 64 caracteres'),
    contest_date: z
      .string()
      .min(1, 'Campo obrigatório')
      .refine(
        (data) => {
          if (data.length < 10) return false
          return isValidDateString(data)
        },
        { message: 'Use uma data válida' },
      ),
  }),
  contract: z.object({
    global_value: z.string().min(1, { message: 'Campo obrigatório' }),
    duration_in_months: optionSchema,
  }),
})

export type PublicClientsFunnelValidationSchema = z.infer<typeof createSchema>
